import { PageHeroBand, PageHeroContent } from "~/components/page-hero";
import { m as messages } from "~/lib/i18n";
import {
  STOCKS_HERO_BAND_CLASSNAME,
  STOCKS_HERO_CONTAINER_CLASSNAME,
  STOCKS_HERO_CONTENT_CLASSNAME,
  STOCKS_HERO_SUBTITLE_CLASSNAME,
} from "./stocks-hero-presentation";
import { StocksHeroArtwork } from "./stocks-hero-artwork";

/** Static hero shared by the eager route shell and the loaded page. */
export function StocksHeroHeading() {
  return (
    <PageHeroBand className={STOCKS_HERO_BAND_CLASSNAME}>
      <div className="absolute inset-0">
        <StocksHeroArtwork />
      </div>

      <PageHeroContent
        className={STOCKS_HERO_CONTENT_CLASSNAME}
        containerClassName={STOCKS_HERO_CONTAINER_CLASSNAME}
        skipIntroMotion
        subtitle={messages.stocks_hero_subtitle()}
        subtitleClassName={STOCKS_HERO_SUBTITLE_CLASSNAME}
        title={messages.stocks_hero_title()}
      />
    </PageHeroBand>
  );
}
